import React from "react";
import { useTranslation } from "react-i18next";
import { usePlayer } from "../context/PlayerContext";

// Barre "en lecture" globale, fixée en bas, pilotée par le PlayerContext.
export default function NowPlayingBar() {
  const { t } = useTranslation();
  const player = usePlayer();
  if (!player || !player.current) return null;
  const { current, playing, queueLen, toggle, next, prev, stop } = player;
  const hasQueue = queueLen > 1;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.06)] z-50">
      <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-3">
        <img
          src={current.favicon || "/microphone.png"}
          alt=""
          className="w-11 h-11 rounded-lg object-cover bg-gray-100"
          onError={(e) => { e.currentTarget.src = "/microphone.png"; }}
        />
        <div className="flex-1 min-w-0">
          <div className="font-semibold truncate">{current.name}</div>
          <div className="text-xs text-gray-500 truncate">
            {playing ? t("player.playing") : t("player.paused")}{current.country ? " • " + current.country : ""}
            {hasQueue ? ` • ${t("player.queue", { count: queueLen })}` : ""}
          </div>
        </div>

        {hasQueue && (
          <button onClick={prev} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center" aria-label={t("player.prev")}>⏮</button>
        )}
        <button
          onClick={toggle}
          className="w-11 h-11 rounded-full bg-purple-600 hover:bg-purple-700 text-white text-lg flex items-center justify-center"
          aria-label={t("player.playPause")}
        >
          {playing ? "❚❚" : "►"}
        </button>
        {hasQueue && (
          <button onClick={next} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 flex items-center justify-center" aria-label={t("player.next")}>⏭</button>
        )}
        <button
          onClick={stop}
          className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 flex items-center justify-center"
          aria-label={t("player.stop")}
        >
          ✕
        </button>
      </div>
    </div>
  );
}
